import { Avatar, Drawer, List, Stack, Toolbar } from "@mui/material";
import { useState } from "react";
import assets from "../../assets";
import colorConfigs from "../../configs/colorConfigs";
import sizeConfigs from "../../configs/sizeConfigs";
import appRoutes from "../../routes/appRoutes";
import SidebarItem from "./SidebarItem";
import SidebarItemCollapse from "./SidebarItemCollapse";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHashtag } from '@fortawesome/free-solid-svg-icons';

const Sidebar = () => {
  const [openItemId, setOpenItemId] = useState<string | null>(null); // Manage open state

  const handleCopy = () => {
    const text = '1763090'; // ID to be copied
    navigator.clipboard.writeText(text)
      .then(() => {
        alert('Account ID copied!');
      });
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: sizeConfigs.sidebar.width,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: sizeConfigs.sidebar.width,
          boxSizing: "border-box",
          borderRight: "0px",
          background: colorConfigs.sidebar.background,
          color: colorConfigs.sidebar.color,
          scrollbarWidth: sizeConfigs.sidebar.scrollbarwidth,
        },
      }}
    >
      <List disablePadding style={{ borderBottom: '1px solid #ffffff12' }}>
        <Toolbar sx={{
          borderBottom: '1px solid #ffffff12',
          marginBottom: "20px",
          marginTop: "10px",
          display: 'block',
          textAlign: 'left',
        }}>
          <Stack sx={{ width: "100%" }} direction="row" justifyContent="center">
            <img src={assets.images.logo} style={{ width: "100%", height: "auto" }} />
          </Stack>
        </Toolbar>

        {/* Account ID with hover and copy functionality */}
        <div
          style={{
            textAlign: 'center',
            fontFamily: 'sans-serif',
            display: 'flex',
            marginLeft: '10px',
            marginTop: '-10px',
            paddingBottom: '5px',
            borderBottom: '1px solid #ffffff12',
            cursor: 'pointer',
          }}
          onClick={handleCopy} // Handle click to copy ID
        >
          <FontAwesomeIcon icon={faHashtag} aria-hidden="true" style={{ marginRight: '10px' }} />
          <span style={{ fontSize: '13px' }}>ACCOUNT</span>
          <span
            style={{
              fontFamily: 'Copse, serif',
              fontSize: '18px',
              marginLeft: '10px',
              marginTop: '-4px',
              letterSpacing: '1px',
              fontWeight: '500',
            }}
          >
            1763090
          </span>
        </div>

        {/* Sidebar items */}
        {appRoutes.map((route, index) =>
          route.sidebarProps ? (
            route.child ? (
              <SidebarItemCollapse
                item={route}
                openItemId={openItemId}
                setOpenItemId={setOpenItemId}
                key={index}
              />
            ) : (
              <SidebarItem item={route} key={index} />
            )
          ) : null
        )}
      </List>
    </Drawer>
  );
};

export default Sidebar;
